<div ngbDropdown class="d-inline-block">
  <button type="button" class="btn btn-outline-primary" id="dropdownLanguage" ngbDropdownToggle>
    <fa-icon [icon]="['fas', 'earth-americas']" class="me-1"></fa-icon>
    {{ 'languages.' + currentLanguage() | translate }}
  </button>

  <div ngbDropdownMenu aria-labelledby="dropdownLanguage">
    @for (language of languages(); track language) {
      <button ngbDropdownItem [class.active]="currentLanguage() === language" (click)="setLanguage(language)">
        {{ 'languages.' + language | translate }}
      </button>
    }
  </div>
</div>
